import { c as _c } from "react/compiler-runtime";
import { useRef, type RefObject } from 'react';
export interface DarkModeStore {
  subscribe: (onStoreChange: () => void) => () => void;
  snapshot: () => boolean;
}
const getMediaQuery = (mediaQuery: RefObject<MediaQueryList | undefined>) => mediaQuery.current ??= globalThis.matchMedia(`(prefers-color-scheme: dark)`);
export function useDarkModeStore() {
  "use memo";

  const $ = _c(1);
  const mediaQuery = useRef(undefined);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      subscribe: onStoreChange => {
        const abortController = new AbortController();
        getMediaQuery(mediaQuery).addEventListener("change", onStoreChange, {
          passive: true,
          signal: abortController.signal
        });
        return () => {
          abortController.abort();
          mediaQuery.current = undefined;
        };
      },
      snapshot: () => getMediaQuery(mediaQuery).matches
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}